import { useMutation } from "@tanstack/react-query";
import { DefaultErrorResponse } from "@/types";
import client from "@/data/client";
import { enqueueSnackbar } from "notistack";
import { AxiosError } from "axios";

export function useDownloadInvoiceMutation(onSuccess: (data: string) => void) {
  return useMutation(client.invoice.download, {
    onSuccess: (data) => {
      if (typeof data === "string") {
        onSuccess(data);
        enqueueSnackbar("Downloading Invoice", {
          variant: "success",
        });
        return;
      }

      enqueueSnackbar(
        data.message || "An unknown error occurred. Retry later",
        {
          variant: "error",
        },
      );
    },
    onError: (error) => {
      const err = error as AxiosError<DefaultErrorResponse>;
      enqueueSnackbar(
        err.response?.data.message || "An unknown error occurred. Retry later",
        {
          variant: "error",
        },
      );
    },
  });
}
